import React from 'react';
const classname = "cognito-contain";
const content = `
<iframe src="https://services.cognitoforms.com/f/rPkcXZy9Y0ebb9SH421YiA?id=1" style="position:relative;width:1px;min-width:100%;*width:100%;" frameborder="0" scrolling="yes" seamless="seamless" height="600" width="100%"></iframe>
<script src="https://services.cognitoforms.com/scripts/embed.js"></script>    `
export const Cognito = () => (
    
    
    

    <div className={classname} dangerouslySetInnerHTML={{ __html: content }} />
  )

  export default Cognito